(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enjoia-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('enjoia-follower-counter')) {
    customElements.define('enjoia-follower-counter', class extends HTMLElement {
      connectedCallback() {
        if (this.started || this.observer) return;
        this.output = this.querySelector('[data-counter-value]');
        this.original = this.dataset.count || '';
        const match = this.original.trim().match(/^([\d.,\s]+)([kKmM]?)(\+?)$/);
        if (!match || !this.output) return;
        const abbreviated = Boolean(match[2]);
        const number = match[1].replace(/\s/g, '');
        this.target = Number(abbreviated ? number.replace(',', '.') : number.replace(/[.,]/g, ''));
        if (!Number.isFinite(this.target) || this.target < 0) return;
        this.suffix = match[2] + match[3];
        this.decimals = abbreviated && /[.,]/.test(number) ? 1 : 0;
        this.formatter = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: this.decimals, maximumFractionDigits: this.decimals });
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motionPreference.matches || !('IntersectionObserver' in window)) return;
        this.output.textContent = '0' + this.suffix;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.observer = null;
            this.animateCount();
          }
        }, { threshold: 0.5 });
        this.observer.observe(this);
      }
      animateCount() {
        this.started = true;
        let start;
        const tick = time => {
          if (!this.isConnected) return;
          if (start === undefined) start = time;
          const progress = Math.min((time - start) / 1600, 1);
          if (progress === 1 || this.motionPreference.matches) {
            this.output.textContent = this.original;
            this.frame = null;
            return;
          }
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = this.decimals ? this.target * eased : Math.floor(this.target * eased);
          this.output.textContent = this.formatter.format(value) + this.suffix;
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.started && this.output) this.output.textContent = this.original;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    

if (!window.enjoiaRelatedCartInitialized) {
  window.enjoiaRelatedCartInitialized = true;

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-enjoia-cart-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const status = form.querySelector('.enjoia-card-cart__status');
    const icon = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    const body = new FormData(form);
    body.delete('return_to');
    body.set('sections', 'cart-icon-bubble');
    body.set('sections_url', window.location.pathname);
    const url = new URL(form.action, window.location.origin);
    url.pathname = url.pathname.replace(/\/add\/?$/, '/add.js');
    let added = false;
    try {
      const response = await fetch(url.toString(), {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
      }
      added = true;
      status.textContent = 'Toegevoegd aan je winkelmand';
      button.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
      const html = result.sections && result.sections['cart-icon-bubble'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const current = document.getElementById('cart-icon-bubble');
        const replacement = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
        if (current && replacement) current.innerHTML = replacement.innerHTML;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'enjoia-card-cart', productVariantId: body.get('id'), cartData: result });
      }
    } catch (error) {
      if (!added) status.textContent = error.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
    } finally {
      button.removeAttribute('aria-busy');
      if (added) {
        window.setTimeout(function () {
          button.innerHTML = icon;
          button.disabled = false;
          status.textContent = '';
        }, 1800);
      } else {
        button.disabled = false;
      }
    }
  }, true);

}

  } catch(e) { console.error(e); }
})();
})();
